import { render, staticRenderFns } from "./RightSidebarMenu.vue?vue&type=template&id=3643c61e&scoped=true"
import script from "./RightSidebarMenu.vue?vue&type=script&lang=ts"
export * from "./RightSidebarMenu.vue?vue&type=script&lang=ts"
import style0 from "./RightSidebarMenu.vue?vue&type=style&index=0&id=3643c61e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643c61e",
  null
  
)

export default component.exports